"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FadeArrowRight = void 0;
var React = __importStar(require("react"));
var FadeArrowRight = function (_a) {
  var className = _a.className;
  return React.createElement("svg", {
    className: className,
    width: "16",
    height: "16",
    viewBox: "0 0 30 48"
  }, React.createElement("g", null, React.createElement("rect", {
    x: "21.2",
    y: "20.6",
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 58.9654 23.5757)",
    fill: "#CCCCCC",
    width: "6.8",
    height: "6.8"
  }), React.createElement("rect", {
    x: "16.4",
    y: "15.8",
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 47.3772 18.7757)",
    opacity: "0.8",
    fill: "#CCCCCC",
    width: "6.8",
    height: "6.8"
  }), React.createElement("rect", {
    x: "11.6",
    y: "11",
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 35.7889 13.9757)",
    opacity: "0.6",
    fill: "#CCCCCC",
    width: "6.8",
    height: "6.8"
  }), React.createElement("rect", {
    x: "6.8",
    y: "6.2",
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 24.2007 9.1757)",
    opacity: "0.4",
    fill: "#CCCCCC",
    width: "6.8",
    height: "6.8"
  }), React.createElement("rect", {
    x: "2",
    y: "1.4",
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 12.6125 4.3757)",
    opacity: "0.2",
    fill: "#CCCCCC",
    width: "6.8",
    height: "6.8"
  }), React.createElement("rect", {
    x: "2",
    y: "39.8",
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 -21.3286 77.5654)",
    opacity: "0.2",
    fill: "#CCCCCC",
    width: "6.8",
    height: "6.8"
  }), React.createElement("rect", {
    x: "6.8",
    y: "35",
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 -9.7404 72.7654)",
    opacity: "0.4",
    fill: "#CCCCCC",
    width: "6.8",
    height: "6.8"
  }), React.createElement("rect", {
    x: "11.6",
    y: "30.2",
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 1.8478 67.9654)",
    opacity: "0.6",
    fill: "#CCCCCC",
    width: "6.8",
    height: "6.8"
  }), React.createElement("rect", {
    x: "16.4",
    y: "25.4",
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 13.436 63.1654)",
    opacity: "0.8",
    fill: "#CCCCCC",
    width: "6.8",
    height: "6.8"
  })));
};
exports.FadeArrowRight = FadeArrowRight;